import React, { Component } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { connect } from "react-redux";
import Game from "../components/Game";
import SignIn from "../components/SignIn";
// import {} from "";
class AllRoutes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          {/* <Route exact path="/" element={}/> */}
          {/* <Route exact path="/">
  {loggedIn ? <Redirect to="/dashboard" /> : <PublicHomePage />}
</Route>
 */}
          {/* <Route
            exact
            path="/"
            element={
              this.props.currentUser ? (
                <Game />
              ) : (
                <Navigate replace to={"/signin"} />
              )
            }
          /> */}
          <Route
            exact
            path="/"
            element={
              this.props.currentUser ? (
                <Navigate replace to={"/game"} />
              ) : (
                <SignIn />
              )
            }
          />

          <Route exact path="/" element={<SignIn />} />
          <Route exact path="/game" element={<Game />} />

        </Routes>
      </BrowserRouter>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
  };
};
export default connect(mapStateToProps, null)(AllRoutes);
